module.exports = __webpack_public_path__ + "static/media/prx_01.19300ffb.png";